import React, { memo } from 'react';

import './ViewControls.scss';

function PreviewControls({ children, className = '' }) {
  return <div className={`ViewControls ${className}`}>{children}</div>;
}

export default memo(PreviewControls);
